export const PAYMENT_TYPES = {
  PC: 'PC',
  PP: 'PP',
  PD: 'PD',
  PPD: 'PPD',
  FP: 'FP',
  PPP: 'PPP',
  NT: 'NT'
}
